import { render, staticRenderFns } from "./ButtonBorderedIcon.vue?vue&type=template&id=eeb4f8ca&scoped=true&"
import script from "./ButtonBorderedIcon.vue?vue&type=script&lang=js&"
export * from "./ButtonBorderedIcon.vue?vue&type=script&lang=js&"
import style0 from "./ButtonBorderedIcon.vue?vue&type=style&index=0&id=eeb4f8ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeb4f8ca",
  null
  
)

export default component.exports